(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["consignment-platform"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.consignmentInitialized === 'true') return;
      root.dataset.consignmentInitialized = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-category-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-category-panel]'));
      const select = (tab, focus) => {
        tabs.forEach((item) => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        panels.forEach((panel) => { panel.hidden = panel.dataset.categoryPanel !== tab.dataset.categoryTab; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', (event) => {
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault(); select(tabs[target], true);
        });
      });
    };
    const initializeAll = () => document.querySelectorAll('[data-consignment-root]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebay-live-floating"]) return;
  try {
    
  (function () {
    var storageKey = 'cards-hub-ebay-live-dismissed';

    function initLiveBanner(root) {
      (root || document).querySelectorAll('[data-ebay-live-floating]:not([data-live-initialized])').forEach(function (banner) {
        var closeButton = banner.querySelector('[data-ebay-live-close]');
        if (!closeButton) return;
        banner.setAttribute('data-live-initialized', 'true');
        var dismissed = false;
        try { dismissed = window.sessionStorage.getItem(storageKey) === 'true'; } catch (error) {}
        banner.hidden = dismissed;
        closeButton.addEventListener('click', function () {
          banner.hidden = true;
          try { window.sessionStorage.setItem(storageKey, 'true'); } catch (error) {}
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initLiveBanner(document); }, { once: true });
    } else {
      initLiveBanner(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initLiveBanner(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('[data-cart-form][data-psa-cart-invalid]')) return;
    if (event.submitter && event.submitter.name === 'update') return;
    event.preventDefault();
    const message = form.querySelector('.cart-psa-error');
    if (message) message.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    function normalizeProductSearch() {
      if (!document.querySelector('[data-global-product-search]')) return;
      var url = new URL(window.location.href);
      var requiresUpdate = url.searchParams.get('type') !== 'product';
      if (url.searchParams.has('filter.p.m.custom.storefront_area')) {
        url.searchParams.delete('filter.p.m.custom.storefront_area');
        requiresUpdate = true;
      }
      if (!requiresUpdate) return;
      url.searchParams.set('type', 'product');
      window.location.replace(url.toString());
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', normalizeProductSearch, { once: true });
    } else {
      normalizeProductSearch();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psa-grading"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psa-submission')) {
    class PsaSubmission extends HTMLElement {
      static equalItem(actual, expected) {
        return Number(actual.variant_id || actual.id) === Number(expected.id) && actual.quantity === expected.quantity && Object.entries(expected.properties).every(([key, value]) => String((actual.properties || {})[key] ?? '') === String(value));
      }
      static reconcile(cart, expected, submissionId) {
        const owned = cart.items.filter(item => (item.properties || {})._psa_submission_id === submissionId);
        const ids = new Set(expected.map(item => item.properties._psa_line_id));
        if (owned.some(item => !ids.has(item.properties._psa_line_id))) return { conflict: true, missing: [] };
        const missing = [];
        for (const item of expected) {
          const found = owned.filter(actual => actual.properties._psa_line_id === item.properties._psa_line_id);
          if (found.length > 1 || (found.length === 1 && !PsaSubmission.equalItem(found[0], item))) return { conflict: true, missing: [] };
          if (!found.length) missing.push(item);
        }
        return { conflict: false, missing };
      }
      static cartIntegrity(cart, excludeSubmission = '') {
        const groups = new Map();
        const lineIds = new Set();
        for (const item of cart.items) {
          const p = item.properties || {};
          if (!p._psa_role && !p._psa_submission_id && !String(item.sku || '').startsWith('CH-PSA-')) continue;
          if (excludeSubmission && p._psa_submission_id === excludeSubmission) continue;
          if (!Number.isInteger(item.quantity) || item.quantity < 1 || (p._psa_role !== 'return_shipping' && item.quantity !== 1) || !p._psa_submission_id || !p._psa_line_id || lineIds.has(p._psa_line_id) || !['card', 'preparation', 'insurance', 'return_shipping'].includes(p._psa_role)) return false;
          lineIds.add(p._psa_line_id);
          if (!groups.has(p._psa_submission_id)) groups.set(p._psa_submission_id, []);
          groups.get(p._psa_submission_id).push(item);
        }
        for (const items of groups.values()) {
          const cards = items.filter(item => item.properties._psa_role === 'card');
          if (!cards.length) return false;
          const cardIds = new Set();
          let valueCents = 0;
          const returnMethod = cards[0].properties._psa_return_method;
          const insuranceRequested = cards[0].properties._psa_insurance_requested;
          if (!['ship', 'pickup'].includes(returnMethod) || !['Yes', 'No'].includes(insuranceRequested)) return false;
          if (items.some(item => item.properties._psa_return_protection_requested !== undefined)) {
            const requested = cards[0].properties._psa_return_protection_requested;
            if (!['Yes', 'No'].includes(requested) || (requested === 'Yes' && returnMethod !== 'ship')) return false;
            const label = requested === 'Yes' ? 'Requested: quote and payment after grading' : 'Not requested';
            if (items.some(item => item.properties._psa_return_protection_requested !== requested || item.properties['Return protection request'] !== label)) return false;
          }
          for (const card of cards) {
            const p = card.properties;
            const declared = Number(p['Declared value (EUR)']);
            if (!p._psa_card_id || cardIds.has(p._psa_card_id) || !['Card name', 'Year', 'Set', 'Card number', 'Language'].every(key => String(p[key] || '').trim()) || !Number.isFinite(declared) || declared <= 0 || p._psa_schema !== '2' || p._psa_terms_accepted !== 'Yes' || !p._psa_terms_version || p._psa_packing_terms_accepted !== 'Yes' || !['self', 'cardshub'].includes(p._psa_packing_choice) || p._psa_return_method !== returnMethod || p._psa_insurance_requested !== insuranceRequested) return false;
            cardIds.add(p._psa_card_id);
            valueCents += Math.round(declared * 100);
            const preparation = items.filter(item => item.properties._psa_role === 'preparation' && item.properties._psa_linked_card === p._psa_card_id);
            if (preparation.length !== (p._psa_packing_choice === 'cardshub' ? 1 : 0)) return false;
          }
          for (const item of items.filter(item => item.properties._psa_role === 'preparation')) {
            if (!cards.some(card => card.properties._psa_card_id === item.properties._psa_linked_card && card.properties._psa_packing_choice === 'cardshub')) return false;
          }
          const returns = items.filter(item => item.properties._psa_role === 'return_shipping');
          const insurance = items.filter(item => item.properties._psa_role === 'insurance');
          if (returns.length !== (returnMethod === 'ship' ? 1 : 0) || insurance.length !== (insuranceRequested === 'Yes' ? 1 : 0)) return false;
          if (returns.length && returns[0].quantity !== cards.length) return false;
          if (insurance.length) {
            const p = insurance[0].properties;
            if (Math.round(Number(p['Combined declared value (EUR)']) * 100) !== valueCents || !(Number(p['Coverage limit (EUR)']) * 100 >= valueCents)) return false;
          }
        }
        return true;
      }
      static insuranceTier(tiers, value) {
        return tiers.find(tier => value > 0 && value <= tier.limit) || null;
      }
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-psa-config]').textContent);
        this.strings = this.config.strings;
        this.form = this.querySelector('[data-builder]');
        this.list = this.querySelector('[data-card-list]');
        this.dialog = this.querySelector('[data-review-dialog]');
        this.button = this.querySelector('[data-checkout]');
        this.setupContactForm();
        this.mode = 'card';
        this.busy = false;
        this.storageKey = 'cards-hub-psa-draft-v1';
        this.rootPath = this.config.root.endsWith('/') ? this.config.root : this.config.root + '/';
        let saved = null;
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); } catch (_) { saved = null; }
        if (saved?.checkoutStarted) {
          try {
            const cart = await this.request('cart.js');
            if (!cart.items.some(item => item.properties?._psa_submission_id === saved.submissionId)) saved = null;
          } catch (_) { }
        }
        this.checkoutStarted = Boolean(saved?.checkoutStarted);
        this.querySelector('[data-insurance]').checked = Boolean(saved?.insuranceRequested) && this.config.insuranceEnabled;
        this.submissionId = saved?.submissionId || this.idToken('PSA');
        this.uncertain = Boolean(saved?.uncertain);
        this.querySelector('[data-reference]').textContent = this.submissionId;
        if (Array.isArray(saved?.cards) && saved.cards.length && saved.cards.length <= 50) {
          saved.cards.forEach(card => this.addCard(card));
          this.querySelector('[data-inbound]').value = saved.inbound === 'ship' ? 'ship' : 'store';
          if (saved.returnMethod === 'ship' && (!this.config.enabled || this.config.shipping.id)) this.querySelector('[data-return]').value = 'ship';
        } else this.addCard();
        this.syncReturnProtection(saved?.returnProtectionRequested === true);
        this.querySelector('[data-add-card]').addEventListener('click', () => {
          if (this.list.children.length >= 50) { this.showError(this.strings.max_cards); return; }
          this.addCard({ mode: this.mode });
          this.refresh();
          this.list.lastElementChild.querySelector('input').focus();
        });
        this.list.addEventListener('click', event => {
          const remove = event.target.closest('[data-remove-card]');
          if (!remove || this.list.children.length <= 1 || this.busy) return;
          remove.closest('[data-card-id]').remove();
          this.refresh();
        });
        this.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => {
          this.mode = button.dataset.mode;
          this.querySelectorAll('[data-mode]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          this.renderTiers();
        }));
        this.querySelectorAll('[data-select-tier]').forEach(button => button.addEventListener('click', () => {
          const first = this.list.firstElementChild;
          first.querySelector('[data-field="tier"]').value = button.dataset.selectTier;
          first.querySelector('[data-field="mode"]').value = this.mode;
          this.refresh();
          this.form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          first.querySelector('input').focus({ preventScroll: true });
        }));
        this.form.addEventListener('input', () => this.refresh());
        this.form.addEventListener('change', () => this.refresh());
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          if (!this.config.enabled || this.busy || !this.validate()) return;
          this.renderDialog();
          this.dialog.showModal();
        });
        this.querySelector('[data-recheck-cart]').addEventListener('click', () => this.recheckCart());
        this.querySelector('[data-edit]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-confirm]').addEventListener('click', () => {
          this.dialog.close();
          this.checkout();
        });
        this.refresh();
        this.renderTiers();
      }
      static contactNeedsOrder(reason) {
        return reason === 'Submission status' || reason === 'Withdrawal';
      }
      setupContactForm() {
        const reason = this.querySelector('[data-contact-reason]');
        const order = this.querySelector('[data-contact-order]');
        if (!reason || !order) return;
        const subject = this.querySelector('[data-contact-subject]');
        const sync = () => {
          order.required = PsaSubmission.contactNeedsOrder(reason.value);
          order.setAttribute('aria-required', String(order.required));
          if (subject) subject.value = reason.value ? 'PSA grading: ' + reason.value : 'PSA grading support';
        };
        reason.addEventListener('change', sync);
        sync();
      }
      idToken(prefix) {
        const token = crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
        return prefix + '-' + token;
      }
      money(cents, currency = this.config.currency, currencyDisplay = 'symbol') {
        if (cents === null || cents === undefined || !Number.isFinite(Number(cents))) return '-';
        return new Intl.NumberFormat(this.config.locale || 'en', { style: 'currency', currency, currencyDisplay }).format(cents / 100);
      }
      addCard(initial = {}) {
        const card = this.querySelector('[data-card-template]').content.firstElementChild.cloneNode(true);
        card.dataset.cardId = initial.id || this.idToken('CARD');
        card.querySelector('[data-preparation-option]').textContent = this.strings.packing_service + ': ' + this.money(this.config.preparation.price);
        card.querySelectorAll('[data-field]').forEach(input => {
          const key = input.dataset.field;
          if (typeof initial[key] === 'string') input.value = initial[key];
        });
        this.list.appendChild(card);
      }
      cards() {
        return Array.from(this.list.children).map(element => {
          const card = { id: element.dataset.cardId, element };
          element.querySelectorAll('[data-field]').forEach(input => { card[input.dataset.field] = input.value.trim(); });
          card.valueNumber = Number(card.value) || 0;
          card.key = card.tier + (card.mode === 'dual' ? '_dual' : '');
          card.service = this.config.services[card.key];
          return card;
        });
      }
      syncReturnProtection(restore) {
        const field = this.querySelector('[data-return-protection]');
        const panel = this.querySelector('[data-return-protection-panel]');
        const ship = this.querySelector('[data-return]').value === 'ship';
        if (!field) return false;
        if (restore !== undefined) field.checked = ship && restore === true;
        if (!ship) field.checked = false;
        if (!this.busy) field.disabled = !ship;
        if (panel) panel.hidden = !ship;
        return ship && field.checked === true;
      }
      saveDraft() {
        const cards = this.cards().map(card => ({ id: card.id, name: card.name, year: card.year, set: card.set, number: card.number, language: card.language, mode: card.mode, tier: card.tier, value: card.value, packing: card.packing, serial: card.serial, notes: card.notes }));
        try { sessionStorage.setItem(this.storageKey, JSON.stringify({ submissionId: this.submissionId, uncertain: this.uncertain, checkoutStarted: this.checkoutStarted, insuranceRequested: this.querySelector('[data-insurance]').checked, returnProtectionRequested: this.syncReturnProtection(), cards, inbound: this.querySelector('[data-inbound]').value, returnMethod: this.querySelector('[data-return]').value })); } catch (_) { }
      }
      state() {
        const cards = this.cards();
        const value = Math.round(cards.reduce((sum, card) => sum + card.valueNumber, 0) * 100) / 100;
        const grading = cards.reduce((sum, card) => sum + (card.service?.price || 0), 0);
        const tier = PsaSubmission.insuranceTier(this.config.insurance, value);
        const insured = Boolean(this.config.insuranceEnabled && this.querySelector('[data-insurance]').checked && tier && (!this.config.enabled || (tier.available && tier.id)));
        const preparationCount = cards.filter(card => card.packing === 'cardshub').length;
        const preparation = preparationCount * (this.config.preparation.price || 0);
        const ship = this.querySelector('[data-return]').value === 'ship';
        const returnProtectionRequested = this.syncReturnProtection();
        const insurance = insured ? tier.price : 0;
        const shipping = ship ? this.config.shipping.price * cards.length : 0;
        return { cards, value, grading, tier, insured, ship, returnProtectionRequested, insurance, shipping, preparation, preparationCount, total: grading + preparation + insurance + shipping };
      }
      refresh() {
        const cards = this.cards();
        cards.forEach((card, index) => {
          card.element.querySelector('[data-card-number]').textContent = this.strings.card_label + ' ' + (index + 1);
          card.element.querySelector('[data-remove-card]').disabled = cards.length === 1;
          const field = card.element.querySelector('[data-field="value"]');
          field.max = String(card.service?.maxValue || 2200);
          field.setCustomValidity(card.valueNumber > Number(field.max) ? this.strings.error_value : '');
          card.element.querySelector('[data-card-price]').textContent = (card.service?.name || '') + ' · ' + this.money(card.service?.price) + (card.packing === 'cardshub' ? ' + ' + this.strings.review_preparation + ' ' + this.money(this.config.preparation.price) : '');
        });
        const state = this.state();
        const insurance = this.querySelector('[data-insurance]');
        const insuranceUsable = this.config.insuranceEnabled && state.tier && (!this.config.enabled || (state.tier.available && state.tier.id));
        insurance.disabled = !insuranceUsable;
        if (!insuranceUsable) insurance.checked = false;
        this.querySelector('[data-insurance-label]').textContent = this.strings.insurance_title + (state.tier ? ': ' + this.money(state.tier.price) + ' · ' + this.strings.value_up_to + ' ' + this.money(state.tier.limit * 100, 'EUR') : '');
        this.querySelector('[data-insurance-quote]').hidden = state.value <= 2500;
        this.querySelector('[data-insurance-status]').textContent = state.value > 2500 ? this.strings.insurance_quote : (!this.config.insuranceEnabled ? this.strings.insurance_pending : (state.value > 0 && !insuranceUsable ? this.strings.insurance_unavailable : ''));
        this.querySelector('[data-summary-count]').textContent = String(cards.length);
        this.querySelector('[data-summary-value]').textContent = this.money(state.value * 100, 'EUR');
        this.querySelector('[data-summary-grading]').textContent = this.money(state.grading);
        this.querySelector('[data-summary-preparation]').textContent = this.money(state.preparation);
        this.querySelector('[data-summary-insurance]').textContent = this.money(state.insurance);
        this.querySelector('[data-summary-shipping]').textContent = this.money(state.shipping);
        this.querySelector('[data-return-timing]').hidden = !state.ship;
        const returnProtection = this.querySelector('[data-summary-return-protection]');
        returnProtection.hidden = !state.ship;
        returnProtection.textContent = state.returnProtectionRequested ? this.strings.return_protection_requested : this.strings.return_protection_not_requested;
        this.querySelector('[data-summary-total]').textContent = this.money(state.total);
        const review = this.querySelector('[data-review-items]');
        review.replaceChildren();
        cards.forEach((card, index) => {
          const row = document.createElement('div'); row.className = 'psa-order__review-row';
          const title = document.createElement('span'); title.textContent = (card.name || this.strings.card_label + ' ' + (index + 1)) + ' · ' + (card.service?.name || '');
          const price = document.createElement('span'); price.textContent = this.money(card.service?.price);
          row.append(title, price); review.appendChild(row);
        });
        this.saveDraft();
      }
      renderTiers() {
        this.querySelectorAll('[data-tier]').forEach(tier => {
          const key = tier.dataset.tier + (this.mode === 'dual' ? '_dual' : '');
          const service = this.config.services[key];
          const title = tier.querySelector('[data-tier-title]');
          if (title) title.textContent = service.name;
          const limit = tier.querySelector('[data-tier-limit]');
          if (limit) limit.textContent = this.strings.value_up_to + ' ' + this.money(service.maxValue * 100, 'EUR');
          const media = tier.querySelector('[data-tier-media]');
          if (media) {
            media.hidden = !service.image?.src;
            if (service.image?.src) {
              let image = media.querySelector('img');
              if (!image) { image = document.createElement('img'); image.className = 'psa-order__tier-image'; image.loading = 'lazy'; media.appendChild(image); }
              image.alt = '';
              image.width = service.image.width;
              image.height = service.image.height;
              image.sizes = '(min-width: 1000px) 31vw, (min-width: 680px) 600px, 92vw';
              image.srcset = service.image.srcset || '';
              image.src = service.image.src;
            }
          }
          tier.querySelector('[data-tier-price]').textContent = this.money(service.price);
          const offer = tier.querySelector('[data-tier-offer]'); offer.replaceChildren();
          const label = document.createElement('span');
          const isLaunch = this.config.launchOffer && this.mode === 'card' && tier.dataset.tier !== 'express';
          tier.querySelector('[data-tier-time]').textContent = service.time + ' ' + this.strings.business_days;
          label.textContent = isLaunch ? this.strings.launch : this.strings.fixed_price;
          offer.appendChild(label);
          if (isLaunch) {
            const normal = document.createElement('small'); normal.textContent = this.strings.regular_after + ' ' + this.money(tier.dataset.tier === 'standard' ? 7500 : 9500, 'EUR', 'code'); offer.appendChild(normal);
          }
        });
      }
      validate() {
        this.querySelector('[data-error]').hidden = true;
        this.refresh();
        if (!this.form.reportValidity()) return false;
        const state = this.state();
        if (!state.cards.length || state.cards.length > 50 || state.cards.some(card => !card.service?.id || !card.service.available || card.valueNumber <= 0 || card.valueNumber > card.service.maxValue || !card.name || !card.year || !card.set || !card.number || !card.language || !['self', 'cardshub'].includes(card.packing))) {
          this.showError(this.strings.error_unavailable); return false;
        }
        if (state.preparationCount && (!this.config.preparation.id || !this.config.preparation.available)) { this.showError(this.strings.error_unavailable); return false; }
        if (state.ship && (!this.config.shipping.id || !this.config.shipping.available)) { this.showError(this.strings.error_unavailable); return false; }
        if (this.querySelector('[data-insurance]').checked && !state.insured) { this.showError(this.strings.error_unavailable); return false; }
        return true;
      }
      renderDialog() {
        const state = this.state();
        const list = this.querySelector('[data-dialog-items]'); list.replaceChildren();
        state.cards.forEach(card => {
          const row = document.createElement('div'); row.className = 'psa-order__dialog-items';
          const title = document.createElement('strong'); title.textContent = card.name + ' · ' + card.service.name + ' · ' + this.money(card.service.price);
          const detail = document.createElement('span'); detail.textContent = [card.year, card.set, card.number, card.language, this.money(card.valueNumber * 100, 'EUR'), card.packing === 'cardshub' ? this.strings.packing_service + ' +' + this.money(this.config.preparation.price) : this.strings.packing_self].join(' · ');
          row.append(title, detail); list.appendChild(row);
        });
        const delivery = document.createElement('p'); delivery.className = 'psa-order__dialog-items'; delivery.textContent = state.ship ? this.strings.return_ship : this.strings.return_pickup; list.appendChild(delivery);
        if (state.ship) {
          const protection = document.createElement('p'); protection.className = 'psa-order__dialog-items'; protection.textContent = state.returnProtectionRequested ? this.strings.return_protection_requested : this.strings.return_protection_not_requested; list.appendChild(protection);
          const timing = document.createElement('p'); timing.className = 'psa-order__return-timing'; timing.textContent = this.strings.return_timing_notice; list.appendChild(timing);
        }
        const coverage = document.createElement('p'); coverage.className = 'psa-order__dialog-items'; coverage.textContent = state.insured ? this.strings.insurance_title + ' · ' + this.money(state.insurance) : this.strings.insurance_none; list.appendChild(coverage);
        this.querySelector('[data-dialog-total]').textContent = this.strings.review_total + ': ' + this.money(state.total);
      }
      buildItems() {
        const state = this.state();
        const inbound = this.querySelector('[data-inbound]').value;
        const early = this.querySelector('[data-consent-early]').checked ? 'Yes' : 'No';
        const common = {
          '_psa_submission_id': this.submissionId, '_psa_schema': '2',
          '_psa_return_method': state.ship ? 'ship' : 'pickup', '_psa_return_protection_requested': state.ship && state.returnProtectionRequested ? 'Yes' : 'No', '_psa_insurance_requested': state.insured ? 'Yes' : 'No', '_psa_terms_version': this.config.termsVersion,
          '_psa_terms_accepted': 'Yes', '_psa_packing_terms_accepted': 'Yes', '_psa_early_start': early,
          '_psa_start_on_physical_receipt': early, '_psa_execution_trigger': early === 'Yes' ? 'physical_receipt' : 'after_receipt_and_applicable_withdrawal_period',
          'Early service start on physical receipt': early, 'Submission reference': this.submissionId,
          'Handover': inbound === 'store' ? 'In-store handover' : 'Ship to Cards Hub',
          'Return method': state.ship ? 'Return shipping: rate selected at checkout' : 'In-store collection',
          'Return protection request': state.ship && state.returnProtectionRequested ? 'Requested: quote and payment after grading' : 'Not requested'
        };
        const items = state.cards.map((card, index) => ({ id: card.service.id, quantity: 1, properties: {
          ...common, '_psa_role': 'card', '_psa_card_id': card.id, '_psa_line_id': card.id, '_psa_packing_choice': card.packing,
          'Card preparation': card.packing === 'cardshub' ? 'Cards Hub: sleeve + Card Saver' : 'Customer: sleeve + Card Saver required',
          'Card reference': String(index + 1).padStart(3, '0') + ' / ' + card.id,
          'Card name': card.name, 'Year': card.year, 'Set': card.set, 'Card number': card.number,
          'Language': card.language, 'Declared value (EUR)': card.valueNumber.toFixed(2), 'Service': card.service.name,
          'Serial / autograph': card.serial || '-', 'Notes': card.notes || '-'
        }}));
        state.cards.forEach((card, index) => {
          if (card.packing !== 'cardshub') return;
          items.push({ id: this.config.preparation.id, quantity: 1, properties: {
            ...common, '_psa_role': 'preparation', '_psa_line_id': card.id + '-preparation', '_psa_card_id': card.id,
            '_psa_linked_card': card.id, '_psa_packing_choice': 'cardshub',
            'Linked card': String(index + 1).padStart(3, '0') + ' / ' + card.id, 'Card name': card.name,
            'Card preparation': 'Cards Hub: sleeve + Card Saver'
          }});
        });
        if (state.insured) items.push({ id: state.tier.id, quantity: 1, properties: {
          ...common, '_psa_role': 'insurance', '_psa_line_id': this.submissionId + '-insurance',
          'Coverage limit (EUR)': String(state.tier.limit), 'Combined declared value (EUR)': state.value.toFixed(2),
          'Insured journey': 'Cards Hub → PSA'
        }});
        if (state.ship) items.push({ id: this.config.shipping.id, quantity: state.cards.length, properties: {
          ...common, '_psa_role': 'return_shipping', '_psa_line_id': this.submissionId + '-return',
          'Return timing': 'Return shipment starts only after grading is complete and your cards are back from PSA. Carrier dates shown at checkout estimate final transit only, not grading completion.',
          'Service': 'Return shipment after PSA grading', 'Shipment': 'One return shipment for this submission'
        }});
        return items.map(item => {
          const entries = Object.entries(item.properties);
          const first = ['Return timing', 'Card name', 'Card reference', 'Linked card', 'Service', 'Card preparation', 'Declared value (EUR)'];
          const priority = first.flatMap(key => entries.filter(([name]) => name === key));
          const visible = entries.filter(([key]) => !key.startsWith('_') && !first.includes(key));
          const internal = entries.filter(([key]) => key.startsWith('_'));
          return { ...item, properties: Object.fromEntries([...priority, ...visible, ...internal]) };
        });
      }
      showError(message, cartLink = false) {
        const error = this.querySelector('[data-error]'); error.textContent = message; error.hidden = false; error.tabIndex = -1; error.focus();
        this.querySelector('[data-cart-link]').hidden = !cartLink;
        this.querySelector('[data-recheck-cart]').hidden = !this.uncertain;
      }
      async recheckCart() {
        if (this.busy || !this.uncertain) return;
        this.busy = true;
        const recheck = this.querySelector('[data-recheck-cart]');
        recheck.disabled = true;
        try {
          const cart = await this.request('cart.js');
          const result = PsaSubmission.reconcile(cart, this.buildItems(), this.submissionId);
          if (result.conflict) { this.showError(this.strings.error_cart_changed, true); return; }
          if (!PsaSubmission.cartIntegrity(cart, this.submissionId)) { this.showError(this.strings.error_cart_integrity, true); return; }
          this.uncertain = false;
          this.saveDraft();
          this.showError(this.strings.recheck_ready, true);
        } catch (_) { this.showError(this.strings.error_verify, true); }
        finally { this.busy = false; recheck.disabled = false; }
      }
      async request(path, options = {}) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.rootPath + path, { ...options, credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json', ...(options.headers || {}) } });
          if (!response.ok) { const error = new Error('HTTP'); error.definitive = response.status >= 400 && response.status < 500; throw error; }
          return await response.json();
        } finally { clearTimeout(timer); }
      }
      async checkout() {
        if (!this.config.enabled || this.busy || !this.validate()) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.strings.checkout_busy;
        const expected = this.buildItems();
        this.form.querySelectorAll('input,select,textarea,button').forEach(control => { control.dataset.psaPreviousDisabled = control.disabled ? '1' : '0'; control.disabled = true; });
        try {
          const cart = await this.request('cart.js');
          if (!PsaSubmission.cartIntegrity(cart, this.submissionId)) { this.showError(this.strings.error_cart_integrity, true); return; }
          const before = PsaSubmission.reconcile(cart, expected, this.submissionId);
          if (before.conflict) { this.showError(this.strings.error_cart_changed, true); return; }
          if (this.uncertain && before.missing.length) { this.showError(this.strings.error_verify, true); return; }
          if (before.missing.length) {
            this.uncertain = true; this.saveDraft();
            try {
              await this.request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: before.missing }) });
            } catch (error) {
              if (error.definitive) { this.uncertain = false; this.saveDraft(); }
              const afterFailure = await this.request('cart.js');
              const recovered = PsaSubmission.reconcile(afterFailure, expected, this.submissionId);
              if (recovered.conflict || recovered.missing.length) { this.showError(this.uncertain ? this.strings.error_verify : this.strings.error_generic, true); return; }
            }
          }
          const verifiedCart = await this.request('cart.js');
          const verified = PsaSubmission.reconcile(verifiedCart, expected, this.submissionId);
          if (verified.conflict || verified.missing.length) { this.showError(this.strings.error_verify, true); return; }
          if (!PsaSubmission.cartIntegrity(verifiedCart)) { this.showError(this.strings.error_cart_integrity, true); return; }
          this.uncertain = false; this.checkoutStarted = true; this.saveDraft();
          window.location.assign(this.rootPath + 'checkout');
        } catch (_) { this.showError(this.uncertain ? this.strings.error_verify : this.strings.error_generic, this.uncertain); }
        finally {
          this.busy = false;
          this.form.querySelectorAll('[data-psa-previous-disabled]').forEach(control => { control.disabled = control.dataset.psaPreviousDisabled === '1'; delete control.dataset.psaPreviousDisabled; });
          this.button.disabled = !this.config.enabled;
          this.button.textContent = this.config.enabled ? this.strings.checkout : this.strings.checkout_disabled;
        }
      }
    }
    customElements.define('psa-submission', PsaSubmission);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-your-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.consignmentInitialized === 'true') return;
      root.dataset.consignmentInitialized = 'true';
      root.querySelectorAll('[data-sell-service]').forEach((link) => {
        link.addEventListener('click', () => {
          const name = link.dataset.sellService;
          root.querySelectorAll('[data-sell-panel]').forEach((panel) => { panel.open = panel.dataset.sellPanel === name; });
        });
      });

      const tabs = Array.from(root.querySelectorAll('[data-category-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-category-panel]'));
      const select = (tab, focus) => {
        tabs.forEach((item) => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        panels.forEach((panel) => { panel.hidden = panel.dataset.categoryPanel !== tab.dataset.categoryTab; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', (event) => {
          let target = index;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          else return;
          event.preventDefault(); select(tabs[target], true);
        });
      });
    };
    const initializeAll = () => document.querySelectorAll('[data-consignment-root]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
